export default "__VITE_ASSET__Ds3UPbLs__"